import gql from 'graphql-tag';

export const GET_USER_TEAMS_QUERY = gql`
  query GetUserTeams($organisationId: String!) {
    getUserTeams(organisationId: $organisationId) {
      teamId
      name
      imageUrl
      creditBalance {
        balanceId
        balance
        rolloverBalance
      }
      creditRule {
        creditRuleId
        startDate
        endDate
        creditQuantity
      }
    }
  }
`;

const getUserTeams = (organisationId) => ({
  query: GET_USER_TEAMS_QUERY,
  module: 'users',
  ignoreCache: true,
  buildVariables: () => ({ organisationId }),
  isSilent: true
});

export default getUserTeams;